var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
      _c("span", [_vm._v("Client Product List")]),
    ]),
    _c(
      "div",
      { staticClass: "ca-form" },
      [
        _vm.isLoading
          ? _c("div", [_vm._v("Loading Please wait...")])
          : _vm.list.length === 0
          ? _c("div", [
              _c(
                "span",
                [
                  _vm._v("No Products Specified, yet. "),
                  _c(
                    "el-button",
                    { attrs: { type: "text" }, on: { click: _vm.handleAdd } },
                    [_vm._v("Click to Add one.")]
                  ),
                ],
                1
              ),
            ])
          : _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "5px" },
                    attrs: { type: "secondary", size: "mini", plain: "" },
                    on: { click: _vm.handleAdd },
                  },
                  [_vm._v("Add Product ")]
                ),
              ],
              1
            ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              id: "products-table",
              data: _vm.list,
              fit: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                "class-name": "truncate",
                "min-width": "120px",
                width: "250px",
                label: "Name",
                sortable: "",
                "sort-method": _vm.sortName,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.name) + " ")]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "class-name": "truncate",
                width: "130px",
                label: "Order Type",
                sortable: "",
                "sort-method": _vm.sortOrderType,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.orderType.name) + " ")]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { width: "130px", label: "Fee", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(_vm._s(row.listPrice))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { width: "130px", label: "Vender", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(_vm._s(row.vendorFee))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { width: "85px", label: "Broadcast", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(_vm._s(row.broadcastLimit))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { width: "80px", label: "Distance", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(_vm._s(row.distanceLimit))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { width: "80px", label: "Timeout", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(_vm._s(row.assignmentTimeout))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "class-name": "truncate",
                "min-width": "120px",
                align: "left",
                label: "Description",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.description) + " ")]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: "Actions",
                width: "100",
                fixed: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("el-button", {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-edit",
                          circle: "",
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      }),
                      _c("el-button", {
                        staticStyle: { "margin-left": "5px" },
                        attrs: {
                          type: "warning",
                          size: "mini",
                          icon: "el-icon-delete",
                          circle: "",
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(row.productId)
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }